/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import _ from 'lodash';
import Backbone from 'backbone';
import Radio from 'backbone.radio';
import { View } from 'backbone.marionette';
import Syphon from 'backbone.syphon';
import Ladda from 'ladda';

import { validateForm } from '@/util/ParsleyUtils';

import CreateAssessment from '../../services/CreateAssessment';
import UpdateUserActingAsCommand from '../../../external-dashboard/services/UpdateUserActingAsCommand';
import AssessmentHeaderView from '../../views/AssessmentHeaderView';


import './CreateAssessmentPage.css';

import tmplCreateAssessmentPage from './CreateAssessmentPage.hbs';

const SubmitAssessmentPage = View.extend({
  template: tmplCreateAssessmentPage,

  className: 'create-assessment-page container-fluid',

  ui: {
    assessmentHeader: '.assessment-header',
    assessmentTypeID: '#assessmentTypeID',
    selectAssessmentTypeForm: '.select-assessment-type-form',
    btnCreateAssessment: '.btn-create-assessment'
  },

  regions: {
    assessmentHeader: '@ui.assessmentHeader',
  },

  events: {
    'change @ui.assessmentTypeID': 'onChangeAssessmentType',
    'click @ui.btnCreateAssessment': 'onClickCreateAssessment'
  },

  toggleForm(state) {
    this.$el.find(':input').prop('disabled', !state);
  },

  onRender() {
    this.showChildView(
      'assessmentHeader', 
      new AssessmentHeaderView({
        model: new Backbone.Model({
          commandName: this.model.get('commandName')
        })
      })
    );
  },

  onChangeAssessmentType() {
    const assessmentTypes = this.model.get('assessmentTypes');
    const assessmentType = _.find(assessmentTypes, (x) => x.id === this.ui.assessmentTypeID.val().toString())?.name
    Radio.channel('assessment').trigger('update:header', 'assessmentType', assessmentType);
  },

  async onClickCreateAssessment(e) {
    e.preventDefault();
    const spinner = Ladda.create(this.ui.btnCreateAssessment[0]);
    spinner.start();
    
    try {
      await validateForm(this.ui.selectAssessmentTypeForm);
      const formData = Syphon.serialize(this);
      this.toggleForm(false);
      await UpdateUserActingAsCommand(this.model.get('commandId')); // Ensure the user is acting as the same command as shown in the header
      const assessmentId = await CreateAssessment(formData.assessmentTypeID);
      Radio.channel('navigate').request('show:ext:assessment', assessmentId, true);
    } catch (err) {
      // error handling
    } finally {
      this.toggleForm(true);
      spinner.stop();
    }
  }

});

export default SubmitAssessmentPage;
